(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faqs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOne(root) {
    if (root.__okfInit) return;
    root.__okfInit = true;
    root.querySelectorAll('.okfaq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var body = item.querySelector('.okfaq-a');
        if (item.classList.contains('open')) {
          body.style.maxHeight = '0';
          item.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  function initAll() { document.querySelectorAll('.okfaq').forEach(initOne); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    // open the selected block in the editor for easy editing
    var blk = e.target.closest ? e.target.closest('.okfaq-item') : null;
    if (blk && !blk.classList.contains('open')) {
      var btn = blk.querySelector('.okfaq-q');
      if (btn) btn.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
